'use client';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { useLocaleConfig } from '@/i18n';

type Props = {
  children: React.ReactNode;
};

export default function NextLocalizationProvider({ children }: Props) {
  const { currentLang } = useLocaleConfig();

  return (
    <MuiLocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={currentLang.adapterLocale}>
      {children}
    </MuiLocalizationProvider>
  );
}
